var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Partners.defaultCreditInfoSettings"),
        width: _vm.$selectByLang("450px", "450px", "740px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { border: "1px solid #b5b5b5" } }, [
        _c(
          "div",
          {
            staticClass: "credit",
            attrs: {
              "data-content":
                _vm.$t("Partners.maintainDefaultCreditInfo") + "："
            }
          },
          [
            _c(
              "el-form",
              {
                staticStyle: { "margin-top": "-20px" },
                attrs: {
                  "label-width": _vm.$selectByLang("90px", "90px", "130px"),
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") } },
                  [
                    _c("cargo-owned-branch-select", {
                      attrs: {
                        no: "branchId",
                        "select-type": _vm.selectTypeNames.basic_data_Office_All
                      },
                      on: {
                        change: function($event) {
                          return _vm.queryDefaultCreditInfo()
                        }
                      },
                      model: {
                        value: _vm.form.branchId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "branchId", $$v)
                        },
                        expression: "form.branchId"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "margin-Right50",
                    attrs: { label: _vm.$t("Partners.dateType") }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      },
                      _vm._l(_vm.DATETYPE_TYPE, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.$getLangColumn(item),
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("Invoice.invoice_settlementMethod") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "val1" },
                            model: {
                              value: _vm.creditDateTypeObj.val1,
                              callback: function($$v) {
                                _vm.$set(_vm.creditDateTypeObj, "val1", $$v)
                              },
                              expression: "creditDateTypeObj.val1"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.monthlySettlement"),
                                value: -1
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettleByWeekly"),
                                value: -2
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_FixedDateMonthly"
                                ),
                                value: "n"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.space5"),
                                value: -3
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.dailySettlement"),
                                value: -4
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-input-number", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.creditDateTypeObj.val1 === "n",
                              expression: "creditDateTypeObj.val1==='n'"
                            }
                          ],
                          attrs: {
                            no: "val2",
                            value: _vm.creditDateTypeObj.val2 || undefined,
                            min: 0,
                            precision: 0,
                            controls: false
                          },
                          on: {
                            input: function(val) {
                              _vm.creditDateTypeObj.val2 = val
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "margin-Right50",
                    attrs: { label: _vm.$t("Partners.accountPeriod") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            no: "creditDateLimited",
                            min: 0,
                            precision: 0,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.form.creditDateLimited,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "creditDateLimited", $$v)
                            },
                            expression: "form.creditDateLimited"
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "200px",
                              "margin-left": "5px"
                            },
                            attrs: { no: "termUnit" },
                            model: {
                              value: _vm.form.termUnit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "termUnit", $$v)
                              },
                              expression: "form.termUnit"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: _vm.$t("Partners.day"), value: 0 }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.week"),
                                value: 1
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.month"),
                                value: 2
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Partners.limit") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            no: "credit",
                            min: 0,
                            precision: 0,
                            controls: false
                          },
                          model: {
                            value: _vm.form.credit,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "credit", $$v)
                            },
                            expression: "form.credit"
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              "margin-left": "5px",
                              width: "200px"
                            },
                            attrs: { no: "currency" },
                            model: {
                              value: _vm.form.currency,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "currency", $$v)
                              },
                              expression: "form.currency"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "RMB", value: "RMB" }
                            }),
                            _c("el-option", {
                              attrs: { label: "USD", value: "USD" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c("el-form-item", { attrs: { "label-width": "0" } }, [
                  _c("span", { staticStyle: { color: "darkred" } }, [
                    _vm._v(_vm._s(_vm.$t("Partners.defaultCreditInfoNote")))
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.baoDiCreditEnable
        ? _c(
            "div",
            {
              staticStyle: { border: "1px solid #b5b5b5", "margin-top": "4px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "credit",
                  attrs: {
                    "data-content":
                      _vm.$t("CargoMsg.Cargo_BottomLineCreditControl") + "："
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-top": "-20px" },
                      attrs: {
                        "label-width": _vm.$selectByLang(
                          "90px",
                          "90px",
                          "130px"
                        ),
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "branchId2",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              disabled: true,
                              "default-value": _vm.baoDiForm.branchId || "",
                              "tag-name": "code",
                              placeholder: " "
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.dateType") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "remarks2" },
                              model: {
                                value: _vm.baoDiForm.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.baoDiForm, "remarks", $$v)
                                },
                                expression: "baoDiForm.remarks"
                              }
                            },
                            _vm._l(_vm.DATETYPE_TYPE, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.$getLangColumn(item),
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.accountPeriod") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "creditDateLimited2",
                                  min: 0,
                                  precision: 0,
                                  "controls-position": "right"
                                },
                                model: {
                                  value: _vm.baoDiForm.creditDateLimited,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.baoDiForm,
                                      "creditDateLimited",
                                      $$v
                                    )
                                  },
                                  expression: "baoDiForm.creditDateLimited"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "5px"
                                  },
                                  attrs: { no: "termUnit2" },
                                  model: {
                                    value: _vm.baoDiForm.termUnit,
                                    callback: function($$v) {
                                      _vm.$set(_vm.baoDiForm, "termUnit", $$v)
                                    },
                                    expression: "baoDiForm.termUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("span", { staticStyle: { color: "darkred" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BaoDiCreditInfoNote"))
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }